/* eslint-disable */

"use client";
import { useEffect, useState } from "react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import svgPaths from "@/svg/headerPaths";
import {
  img,
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
} from "@/imports/svg-59rgz";
import { PersonalizationToast } from "@/components/common/PersonalizationToast";
import BottomToast from "@/components/common/BottomToast";
import { getAuthStatus } from "@/lib/auth";
import ProfileModal from "@/components/common/ProfileModal";
import { getServicePeriodText, getServicePeriodColor } from "@/lib/service-utils";
import { 
  getPersonalizationEnabled, 
  setPersonalizationEnabled, 
  checkPersonalizationAvailable,
  initializePersonalizationOnLogin,
  initializePersonalizationOnLogout,
  getPersonalizationEnabledFor,
  setPersonalizationEnabledFor
} from "@/lib/personalization";
import { authService } from "@/services/auth.service";
import { reportService } from "@/services/report.service";

const spacing = {
  xs: "0.25rem",
  sm: "0.5rem",
  md: "0.75rem",
  lg: "1rem",
  xl: "1.5rem",
  "2xl": "3.125rem",
};

const radius = {
  sm: "0.25rem",
  md: "0.5rem",
  lg: "1rem",
  xl: "1.75rem",
};

// CategoryDropdown는 더 이상 사용하지 않습니다 (인라인 렌더링으로 대체)

function RecommendedKeywords() {
  return (
    <div className="flex items-center">
      <h3 className="text-white text-lg font-semibold" style={{ fontFamily: 'var(--font-noto-sans-kr)' }}>
        추천검색어
      </h3>
    </div>
  );
}

function SearchQuery2024Ai() {
  return <img className="w-[176.763px] h-3.5" src={img11} alt="2024년 AI 마케팅 트렌드는?" />;
}
function SearchQueryRoi() {
  return <img className="w-[158.762px] h-[14.047px]" src={img12} alt="소셜 미디어 ROI 측정 방법" />;
}
function SearchQueryB2B() {
  return <img className="w-[175.849px] h-3.5" src={img13} alt="B2B 콘텐츠 마케팅 성공 사례" />;
}
function SearchQueryGa4() {
  return <img className="w-[192.982px] h-[14.156px]" src={img14} alt="GA4 활용한 데이터 분석 가이드" />;
}

function SearchSuggestionsList({ prompts, onPick }: { prompts: string[]; onPick: (text: string) => void }) {
  const safe = Array.isArray(prompts) ? prompts.filter(Boolean) : [];
  if (safe.length === 0) return null;
  return (
    <div className="content-stretch flex flex-col gap-4 items-start justify-start relative shrink-0 w-full">
      {safe.map((p, idx) => (
        <button
          key={idx}
          onMouseDown={(e) => { e.preventDefault(); onPick(p); }}
          className="flex items-center text-left hover:opacity-80 transition-opacity cursor-pointer"
        >
          <span className="text-white/90 text-base" style={{ fontFamily: 'var(--font-noto-sans-kr)' }}>{p}</span>
        </button>
      ))}
    </div>
  );
}

function RecommendedSearchDropdown({ isOpen, prompts, onPick }: { isOpen: boolean; prompts: string[]; onPick: (text: string) => void }) {
  if (!isOpen) return null;
  return (
    <div className="absolute bg-[#010103] box-border content-stretch flex flex-col gap-6 items-start justify-start left-0 px-6 py-8 rounded-bl-[26px] rounded-br-[26px] shadow-[0px_0px_18px_0px_rgba(162,171,173,0.2)] top-[22px] w-full max-w-[900px]">
      <div className="w-full h-px opacity-40">
        <img className="w-full h-full" src={img5} alt="분리선" />
      </div>
      <RecommendedKeywords />
      <SearchSuggestionsList prompts={prompts} onPick={onPick} />
    </div>
  );
}

function PersonalizeIcon({ isActive }: { isActive: boolean }) {
  return (
    <div className="w-[26px] h-[26px]">
      {isActive ? (
        <img className="w-full h-full" src={img4} alt="개인화 활성" />
      ) : (
        <svg className="w-full h-full" fill="none" preserveAspectRatio="none" viewBox="0 0 26 26">
          <g>
            <g opacity="0.6">
              <path d={svgPaths.p16e23500} fill="white" />
              <path d={svgPaths.p9556200} fill="white" />
              <path d={svgPaths.p3e5a2f70} fill="white" />
              <path d={svgPaths.p2130f070} fill="white" />
              <path d={svgPaths.p1e16afc0} fill="white" />
              <path d={svgPaths.p100aa300} fill="white" />
            </g>
          </g>
        </svg>
      )}
    </div>
  );
}

function PersonalizeButton({ isActive, onClick }: { isActive: boolean; onClick: () => void }) {
  return (
    <button className="content-stretch flex flex-col h-14 items-center justify-center relative shrink-0 w-[75px] cursor-pointer hover:opacity-80 transition-opacity" onClick={onClick}>
      <PersonalizeIcon isActive={isActive} />
    </button>
  );
}

function SearchIcon() {
  return (
    <div className="relative shrink-0 size-[26px]">
      <img src="/svg/magnifier.svg" alt="search" className="block size-full" />
    </div>
  );
}

function SearchIconArea({ onClick }: { onClick: () => void }) {
  return (
    <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={onClick} aria-label="검색"
      className="content-stretch flex flex-col h-14 items-center justify-center overflow-clip relative shrink-0 w-[60px] cursor-pointer">
      <SearchIcon />
    </button>
  );
}

function SearchInputForm({ onFocus, onBlur, value, onChange, onSubmit }: { onFocus: () => void; onBlur: () => void; value: string; onChange: (value: string) => void; onSubmit: () => void }) {
  return (
    <div className="basis-0 grow h-14 min-h-px min-w-px relative shrink-0">
      <div className="flex flex-row items-center relative size-full">
        <div className="box-border content-stretch flex h-14 items-center justify-start pl-0 pr-[50px] py-4 relative w-full">
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); onSubmit(); } }}
            placeholder="AI가 큐레이션하는 인사이트를 검색하세요"
            className="basis-0 bg-transparent border-none outline-none font-['Pretendard:Medium',_sans-serif] grow h-6 min-h-px min-w-px not-italic relative shrink-0 text-[16px] text-[rgba(255,255,255,0.8)] tracking-[-0.32px] placeholder:text-[rgba(255,255,255,0.8)] placeholder:leading-[21px]"
            style={{ fontSize: "16px", fontWeight: 500, letterSpacing: "-0.32px", lineHeight: "21px" }}
          />
        </div>
      </div>
    </div>
  );
}

function SearchInputBar({ personalizeActive, onPersonalizeToggle, onSearchFocus, onSearchBlur, searchValue, onSearchChange, onSubmit }: {
  personalizeActive: boolean;
  onPersonalizeToggle: () => void;
  onSearchFocus: () => void;
  onSearchBlur: () => void;
  searchValue: string;
  onSearchChange: (value: string) => void;
  onSubmit: () => void;
}) {
  return (
    <div className="absolute bg-[#010103] content-center flex flex-wrap gap-px h-14 items-center justify-start left-0 rounded-[28px] top-0 w-full max-w-[900px]">
      <PersonalizeButton isActive={personalizeActive} onClick={onPersonalizeToggle} />
      <div className="h-[22px] relative shrink-0 w-px">
        <div className="absolute bottom-0 left-[-50%] right-1/2 top-0">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 2 22">
            <path d="M1 0V22" stroke="white" strokeOpacity="0.4" />
          </svg>
        </div>
      </div>
      <SearchIconArea onClick={onSubmit} />
      <SearchInputForm onFocus={onSearchFocus} onBlur={onSearchBlur} value={searchValue} onChange={onSearchChange} onSubmit={onSubmit} />
    </div>
  );
}

function SearchInputFormGroup({ searchFocused, personalizeActive, onPersonalizeToggle, onSearchFocus, onSearchBlur, searchValue, onSearchChange, prompts, onPickPrompt, onSubmit }: {
  searchFocused: boolean;
  personalizeActive: boolean;
  onPersonalizeToggle: () => void;
  onSearchFocus: () => void;
  onSearchBlur: () => void;
  searchValue: string;
  onSearchChange: (value: string) => void;
  prompts: string[];
  onPickPrompt: (text: string) => void;
  onSubmit: () => void;
}) {
  return (
    <div className="relative size-full">
      <RecommendedSearchDropdown isOpen={searchFocused} prompts={prompts} onPick={onPickPrompt} />
      <SearchInputBar
        personalizeActive={personalizeActive}
        onPersonalizeToggle={onPersonalizeToggle}
        onSearchFocus={onSearchFocus}
        onSearchBlur={onSearchBlur}
        searchValue={searchValue}
        onSearchChange={onSearchChange}
        onSubmit={onSubmit}
      />
    </div>
  );
}

function CategoryButton({ size = "md", tone = "ghost", state = "default", isOpen, onClick }: Partial<{ size: "sm" | "md" | "lg"; tone: "primary" | "secondary" | "ghost"; state: "default" | "active" | "focus" | "hover"; }> & { isOpen: boolean; onClick: () => void; }) {
  const baseClasses = "flex items-center justify-center gap-2.5 cursor-pointer transition-all duration-200";
  const sizeClasses = { sm: "h-8 px-3", md: "h-11 px-0", lg: "h-12 px-4" }[size];
  const toneClasses = { primary: "bg-primary text-primary-foreground", secondary: "bg-secondary text-secondary-foreground", ghost: "bg-transparent text-foreground hover:bg-transparent" }[tone];
  const stateClasses = { default: "", active: "bg-accent", focus: "ring-2 ring-ring", hover: "opacity-80" }[state];
  return (
    <div className="relative">
      <button className={`${baseClasses} ${sizeClasses} ${toneClasses} ${stateClasses} w-[120px]`} onClick={onClick} style={{ fontSize: "16px", fontWeight: 500, letterSpacing: "-0.32px" }}>
        <span className="whitespace-pre">카테고리</span>
        <div className="w-[9.4px] h-[5.193px]">
          <svg className="w-full h-full" fill="none" preserveAspectRatio="none" viewBox="0 0 10 6">
            <path d={svgPaths.p259fb0f0} fill="currentColor" />
          </svg>
        </div>
      </button>
    </div>
  );
}

function LoginButton({ size = "md", tone = "secondary", onClick }: Partial<{ size: "sm" | "md" | "lg"; tone: "primary" | "secondary" | "ghost" }> & { onClick?: () => void }) {
  const baseClasses = "flex items-center justify-center cursor-pointer transition-all duration-200 border border-[#9a9992]";
  const sizeClasses = { sm: "h-8 px-4", md: "h-auto px-6 py-2.5", lg: "h-12 px-8" }[size!];
  const toneClasses = { primary: "bg-primary text-primary-foreground", secondary: "bg-[#f8f8f8] text-foreground", ghost: "bg-transparent text-foreground" }[tone!];
  return (
    <button onClick={onClick} className={`${baseClasses} ${sizeClasses} ${toneClasses}`} style={{ borderRadius: radius.md, fontSize: "16px", fontWeight: 500 }}>
      <span className="whitespace-pre">로그인</span>
    </button>
  );
}

function UserBadge({ name }: { name: string }) {
  return (
    <div className="h-10 relative flex items-center justify-end" style={{ gap: '20px' }}>
      <div className="text-right text-black text-base font-normal" style={{ fontFamily: 'var(--font-noto-sans-kr)' }}>{name} 님</div>
      <img data-layer="Ellipse 600" className="size-10 rounded-full border border-gray-400" src="/svg/Ellipse-600.svg" alt="avatar" />
    </div>
  );
}

function UserDropdown({ onLogout, onProfile, onPersonalization, serviceExpiresAt }: { onLogout: () => void; onProfile: () => void; onPersonalization: () => void; serviceExpiresAt?: Date | string | null }) {
  const servicePeriodText = getServicePeriodText(serviceExpiresAt ?? null);
  const servicePeriodColor = getServicePeriodColor(serviceExpiresAt ?? null);
  
  // 색상을 직접 매핑
  const getTextColorClass = (color: string) => {
    if (color === 'text-red-500') return 'text-red-400';
    if (color === 'text-yellow-500') return 'text-yellow-400';
    if (color === 'text-green-500') return 'text-green-400';
    return 'text-white';
  };
  
  return (
    <div className="User w-32 h-60 relative">
      <div className="w-32 h-60 left-0 top-0 absolute bg-gray-900/60 rounded-2xl backdrop-blur-[5px]" />
      <div className="left-[16px] top-[12px] absolute inline-flex flex-col justify-start items-start gap-3 pb-5">
        {/* 서비스 기간 표시 */}
        <div className="w-full px-2 py-2 bg-white/10 rounded-lg backdrop-blur-sm text-center">
          <div className="text-xs text-white/80 mb-1" style={{ fontFamily: 'var(--font-noto-sans-kr)' }}>남은서비스기간</div>
          <div className={`text-lg font-bold ${getTextColorClass(servicePeriodColor)} [text-shadow:_0px_0px_8px_rgb(0_0_0_/_0.08)]`} style={{ fontFamily: 'var(--font-noto-sans-kr)' }}>
            {servicePeriodText}
          </div>
        </div>
        
        <button onClick={onProfile} className="self-stretch text-left text-white text-base font-medium [text-shadow:_0px_0px_8px_rgb(0_0_0_/_0.08)] hover:opacity-80 transition-opacity" style={{ fontFamily: 'var(--font-noto-sans-kr)' }}>프로필</button>
        <a href="/scraps" className="text-white text-base font-medium [text-shadow:_0px_0px_8px_rgb(0_0_0_/_0.08)]" style={{ fontFamily: 'var(--font-noto-sans-kr)' }}>스크랩</a>
        <button onClick={onPersonalization} className="self-stretch text-left text-white text-base font-medium [text-shadow:_0px_0px_8px_rgb(0_0_0_/_0.08)] hover:opacity-80 transition-opacity" style={{ fontFamily: 'var(--font-noto-sans-kr)' }}>관심사 설정</button>
        <button onClick={onLogout} className="self-stretch text-left text-white text-base font-medium cursor-pointer hover:opacity-80 transition-opacity [text-shadow:_0px_0px_8px_rgb(0_0_0_/_0.08)]" style={{ fontFamily: 'var(--font-noto-sans-kr)' }}>로그아웃</button>
      </div>
    </div>
  );
}

function DWLogo() {
  return (
    <Link href="/" className="flex items-center gap-0 cursor-pointer hover:opacity-80 transition-opacity">
      <svg width="48" height="18" viewBox="0 0 48 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.0948 1.09343C12.9712 0.0479396 10.8976 0.00203998 10.6681 0H0V8.98508V17.9702H10.6681C10.8976 17.9681 12.9712 17.9222 15.0948 16.8767C18.1334 15.3804 19.8072 12.5775 19.8072 8.98508C19.8072 5.39268 18.1334 2.58975 15.0948 1.09343ZM13.0722 12.5612C11.9512 13.1487 10.7384 13.2089 10.6211 13.2129H4.79191V4.75621H10.6324C10.6925 4.75825 11.8635 4.81129 12.9651 5.35392C14.3635 6.04241 15.0153 7.19602 15.0153 8.98407C15.0153 10.7721 14.3982 11.8655 13.0722 12.5601V12.5612Z" fill="black"/>
        <path d="M24.1916 0.0546875H18.7285L24.9811 10.8972L27.7126 6.16034L24.1916 0.0546875Z" fill="black"/>
        <path d="M41.8856 0.0546875L34.3438 13.2329L37.0753 17.9698L47.3486 0.0546875H41.8856Z" fill="black"/>
        <path d="M33.8118 0.0546875L26.2822 13.1646L29.0138 17.9014L36.5433 4.79152L33.8118 0.0546875Z" fill="black"/>
        <path d="M47.1161 13.1797H42.3242V17.9716H47.1161V13.1797Z" fill="#0248FD"/>
      </svg>
    </Link>
  );
}

function HamburgerMenu({ isOpen, onClick }: { isOpen: boolean; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="lg:hidden flex flex-col justify-center items-center w-6 h-6 space-y-1"
      aria-label="메뉴 토글"
    >
      <span className={`block w-5 h-0.5 bg-black transition-all duration-300 ${isOpen ? 'rotate-45 translate-y-1.5' : ''}`} />
      <span className={`block w-5 h-0.5 bg-black transition-all duration-300 ${isOpen ? 'opacity-0' : ''}`} />
      <span className={`block w-5 h-0.5 bg-black transition-all duration-300 ${isOpen ? '-rotate-45 -translate-y-1.5' : ''}`} />
    </button>
  );
}

function MobileMenu({ isOpen, onClose, categories }: { isOpen: boolean; onClose: () => void; categories: Array<{ code: string; name: string }> }) {
  if (!isOpen) return null;
  
  return (
    <div className="lg:hidden absolute top-16 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-zinc-200 shadow-lg z-40" data-mobile-menu>
      <div className="px-4 py-4 space-y-4">
        <div className="space-y-3">
          {categories.length > 0 ? (
            categories
              .filter(category => category.code !== 'ALL' && category.code !== 'ETC' && category.name !== '기타') // '전체'와 '기타' 카테고리 제외
              .slice(0, 6) // 모바일에서는 최대 6개까지 표시
              .map((category) => (
                <Link 
                  key={category.code}
                  href={`/reportlist?category=${encodeURIComponent(category.code)}`}
                  onClick={onClose}
                  className="block text-black text-base font-medium font-['Pretendard'] hover:opacity-80 transition-opacity py-2"
                >
                  {category.name}
                </Link>
              ))
          ) : (
            // 카테고리 로딩 중일 때 기본 카테고리 표시
            <>
              <span className="block text-black text-base font-medium font-['Pretendard'] py-2">커머스</span>
              <span className="block text-black text-base font-medium font-['Pretendard'] py-2">마케팅</span>
              <span className="block text-black text-base font-medium font-['Pretendard'] py-2">디자인</span>
              <span className="block text-black text-base font-medium font-['Pretendard'] py-2">라이프</span>
            </>
          )}
        </div>
        <div className="border-t border-gray-200 pt-3">
          <Link href="/about" onClick={onClose} className="block text-neutral-500 text-base font-medium font-['Pretendard'] hover:opacity-80 transition-opacity py-2">서비스 소개</Link>
        </div>
      </div>
    </div>
  );
}

export function FloatingHeader({ hideSearch = false, hideCategory = false, onSidebarToggle }: { hideSearch?: boolean; hideCategory?: boolean; onSidebarToggle?: () => void }) {
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [searchFocused, setSearchFocused] = useState(false);
  const [personalizeActive, setPersonalizeActive] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState<string | undefined>(undefined);
  const [toastCtaText, setToastCtaText] = useState<string | undefined>(undefined);
  const [toastHideCTA, setToastHideCTA] = useState<boolean>(false);
  const [loginToastVisible, setLoginToastVisible] = useState(false);
  const [userName, setUserName] = useState<string | null>(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [categories, setCategories] = useState<Array<{ code: string; name: string }>>([]);
  const [hasPersonalization, setHasPersonalization] = useState<boolean | null>(null);
  const [profileOpen, setProfileOpen] = useState(false);
  const [userEmail, setUserEmail] = useState<string | null>(null);
  const [userId, setUserId] = useState<string | null>(null);
  const [userPhone, setUserPhone] = useState<string | null>(null);
  const [userCompany, setUserCompany] = useState<string | null>(null);
  const [serviceExpiresAt, setServiceExpiresAt] = useState<Date | string | null>(null);
  const [promptList, setPromptList] = useState<string[]>([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const router = useRouter();

  // keep search input synced with current q
  useEffect(() => {
    try {
      const qs = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
      const qv = (qs.get('q') || '').trim();
      setSearchValue(qv);
    } catch {}
  }, []);

  // 외부에서 검색어 초기화를 요청하는 커스텀 이벤트 처리
  useEffect(() => {
    function onClear() { setSearchValue(''); }
    try { window.addEventListener('dw:clear_search', onClear as any); } catch {}
    return () => { try { window.removeEventListener('dw:clear_search', onClear as any); } catch {} };
  }, []);

  const handlePersonalizeToggle = async () => {
    if (!userName) {
      setLoginToastVisible(true);
      return;
    }
    try {
      // 개인화 저장 여부 확인 (캐시 없거나 미저장 상태에서는 서버 확인)
      let exists = hasPersonalization;
      if (exists === null || exists === false) {
        exists = await checkPersonalizationAvailable();
        setHasPersonalization(!!exists);
      }
      
      if (exists) {
        setShowToast(false);
        setPersonalizeActive((v) => {
          const next = !v;
          // 사용자별 로컬스토리지에 상태 저장
          if (userId) setPersonalizationEnabledFor(userId, next);
          else setPersonalizationEnabled(next);
          return next;
        });
        return;
      }
      
      // 미저장: 토스트 노출, 아이콘 OFF 유지
      setPersonalizeActive(false);
      if (userId) setPersonalizationEnabledFor(userId, false); else setPersonalizationEnabled(false);
      setToastMessage('개인화 서비스를 이용하시려면 관심사 설정이 필요합니다.');
      setToastCtaText('관심사 설정');
      setToastHideCTA(false);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    } catch {
      // 오류 시에도 사용자 경험상 안내 토스트 유지, 아이콘은 OFF
      setPersonalizeActive(false);
      if (userId) setPersonalizationEnabledFor(userId, false); else setPersonalizationEnabled(false);
      setToastMessage('개인화 서비스를 이용하시려면 관심사 설정이 필요합니다.');
      setToastCtaText('관심사 설정');
      setToastHideCTA(false);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  };

  // 개인화 활성 상태가 바뀌면 전역값/이벤트는 커밋 이후(Effect)로 전달하여 교차 렌더 업데이트 에러 방지
  useEffect(() => {
    try { (window as any).__dw_personalize_active__ = personalizeActive; } catch {}
    try { window.dispatchEvent(new CustomEvent('dw:personalize_toggle', { detail: personalizeActive })); } catch {}
  }, [personalizeActive]);

  const handleAgreeClick = () => {
    try {
      // 마이페이지 모달을 관심사 설정 탭으로 오픈
      setProfileOpen(true);
      // 약간의 지연 후 탭 전환 플래그를 window에 기록 (모달 마운트 이후 적용 보조)
      (window as any).__dw_profile_initial_menu__ = 'personalization';
    } catch {}
  };

  useEffect(() => {
    getAuthStatus()
      .then(async (data) => {
        // To-Be 형식 처리
        // console.log('getAuthStatus::::::::::SSSSSSS222222::::::::::', data);
        if (data?.ok  && data?.user) {
          const user = data?.user;
          if (user?.name) {
            setUserName(user.name as string);
            try { setUserEmail(user.email as string); } catch {}
            try { setUserId(String(user.id ?? '')); } catch {}
            try { setServiceExpiresAt(user.activationExpiresAt || user.activation_expires_at); } catch {}
            try {
              const result = await authService.getPersonalization();
              // To-Be 형식 처리
              const d = result?.code === "SUCCESS" ? (result.data ?? {}) : {};
              const exists = !!(String(d?.job || '').trim()) || !!(String(d?.interests || '').trim());
              setHasPersonalization(exists);
              const prompts = Array.isArray(d?.prompts) ? d.prompts.filter((s: any) => typeof s === 'string' && s.trim()) : [];
              setPromptList(prompts);
              
              // 로그인 시 사용자별 로컬스토리지에서 개인화 설정 불러오기
              const userId = user?.id ? String(user.id) : null;
              if (exists) {
                const pref = userId ? getPersonalizationEnabledFor(userId) : getPersonalizationEnabled();
                setPersonalizeActive(pref);
                (window as any).__dw_personalize_active__ = pref;
                window.dispatchEvent(new CustomEvent('dw:personalize_toggle', { detail: pref }));
              } else {
                // 개인화 데이터가 없으면 전역 비활성화 (사용자별 저장값은 보존)
                setPersonalizeActive(false);
                (window as any).__dw_personalize_active__ = false;
                window.dispatchEvent(new CustomEvent('dw:personalize_toggle', { detail: false }));
              }
              
              // 로그인 이벤트 발생
              window.dispatchEvent(new CustomEvent('dw:auth_change', { detail: { isLoggedIn: true } }));
              // 로그인 직후 백엔드가 prompts를 생성/저장하는 동안 약간의 지연 후 재조회하여 드롭다운 즉시 반영
              setTimeout(async () => {
                try {
                  const result2 = await authService.getPersonalization();
                  // To-Be 형식 처리
                  const d2 = result2?.code === "SUCCESS" ? (result2.data ?? {}) : {};
                  const prompts2 = Array.isArray(d2?.prompts) ? d2.prompts.filter((s: any) => typeof s === 'string' && s.trim()) : [];
                  if (prompts2.length) setPromptList(prompts2);
                } catch {}
              }, 1500);
            } catch {}
          }
        } else {
          // 로그아웃 상태: 사용자별 저장값은 보존하되 전역 활성만 false로
          setPersonalizeActive(false);
          (window as any).__dw_personalize_active__ = false;
          window.dispatchEvent(new CustomEvent('dw:personalize_toggle', { detail: false }));
          // 로그아웃 이벤트 발생
          window.dispatchEvent(new CustomEvent('dw:auth_change', { detail: { isLoggedIn: false } }));
        }
      })
      .catch(() => {})
      .finally(() => { setAuthLoading(false); });
  }, []);

  // 로그인 상태 변경 이벤트 리스너
  useEffect(() => {
    const handleAuthStatusChanged = (event: CustomEvent) => {
      // console.log('[FloatingHeader] Auth status changed:', event.detail);
      if (event.detail.loggedIn && event.detail.user) {
        setUserName(event.detail.user.name || '');
        setUserEmail(event.detail.user.email || '');
        setUserId(String(event.detail.user.id || ''));
        
        // 개인화 정보도 다시 로드
        getAuthStatus().then(async (data) => {
          if (data?.ok) {
            try {
              const result = await authService.getPersonalization();
              // To-Be 형식 처리
              const d = result?.code === "SUCCESS" ? (result.data ?? {}) : {};
              const exists = !!(String(d?.job || '').trim()) || !!(String(d?.interests || '').trim());
              setHasPersonalization(exists);
              const prompts = Array.isArray(d?.prompts) ? d.prompts.filter((s: any) => typeof s === 'string' && s.trim()) : [];
              setPromptList(prompts);
            } catch {}
          }
        });
      }
    };

    window.addEventListener('authStatusChanged', handleAuthStatusChanged as EventListener);
    return () => {
      window.removeEventListener('authStatusChanged', handleAuthStatusChanged as EventListener);
    };
  }, []);

  // 개인화 저장 성공 이벤트 수신 → 즉시 재조회
  useEffect(() => {
    async function onSaved() {
      try {
        const result = await authService.getPersonalization();
        // To-Be 형식 처리
        const d = result?.code === "SUCCESS" ? (result.data ?? {}) : {};
        const prompts = Array.isArray(d?.prompts) ? d.prompts.filter((s: any) => typeof s === 'string' && s.trim()) : [];
        setPromptList(prompts);
      } catch {}
    }
    try { window.addEventListener('dw:personalization_saved', onSaved as any); } catch {}
    return () => { try { window.removeEventListener('dw:personalization_saved', onSaved as any); } catch {} };
  }, []);

  useEffect(() => {
    reportService.getCategories()
      .then((response) => {
        // To-Be 형식 처리
        const data = response.code === "SUCCESS" && response.data?.categories 
          ? response.data.categories 
          : (Array.isArray(response) ? response : []);
        if (Array.isArray(data)) {
          setCategories(data);
        } else {
          // 기본 카테고리로 fallback
          setCategories([
            { code: 'commerce', name: '커머스' },
            // { code: 'marketing', name: '마케팅' },
            // { code: 'design', name: '디자인' },
            // { code: 'life', name: '라이프' },
            // { code: 'ALL', name: '전체' }
          ]);
        }
      })
      .catch(() => {
        // API 호출 실패 시 기본 카테고리로 fallback
        setCategories([
          { code: 'commerce', name: '커머스' },
          // { code: 'marketing', name: '마케팅' },
          // { code: 'design', name: '디자인' },
          // { code: 'life', name: '라이프' },
          // { code: 'ALL', name: '전체' }
        ]);
      });
  }, []);

  // 전역 클릭으로 드롭다운들 닫기 + 상호배타 처리
  useEffect(() => {
    function onDocClick(e: MouseEvent) {
      const t = e.target as HTMLElement;
      const inSearch = !!t.closest('#dw-search-group');
      const inCat = !!t.closest('#dw-category');
      const inUser = !!t.closest('#dw-user-area');
      const inMobileMenu = !!t.closest('[data-mobile-menu]');
      
      if (!inSearch) setSearchFocused(false);
      if (!inCat) setCategoryOpen(false);
      if (!inUser) setUserMenuOpen(false);
      if (!inMobileMenu) setMobileMenuOpen(false);
    }
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const onClickUser = () => {
    setUserMenuOpen((v) => !v);
    setCategoryOpen(false);
    setSearchFocused(false);
  };
  const openProfile = () => {
    try { (window as any).__dw_profile_initial_menu__ = 'profile'; } catch {}
    setProfileOpen(true);
    setUserMenuOpen(false);
  };
  const openPersonalization = () => {
    try { (window as any).__dw_profile_initial_menu__ = 'personalization'; } catch {}
    setProfileOpen(true);
    setUserMenuOpen(false);
  };
  const onLogout = async () => {
    try {
      await authService.logout();
    } catch {}
    
    // 로그아웃 시에도 사용자별 개인화 설정은 보존하며, 전역 활성만 이벤트로 알림
    (window as any).__dw_personalize_active__ = false;
    window.dispatchEvent(new CustomEvent('dw:personalize_toggle', { detail: false }));
    window.dispatchEvent(new CustomEvent('dw:auth_change', { detail: { isLoggedIn: false } }));
    
    window.location.reload();
  };
  const onLogin = () => {
    try {
      if (typeof window !== 'undefined') {
        window.sessionStorage.setItem('dw_prev_path', window.location.pathname);
      }
    } catch {}
    window.location.assign('/auth/login');
  };

  const submitSearch = () => {
    const text = (searchValue || '').trim();
    const qs = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
    // when searching while a category is selected, reset category/sub/sub2
    qs.delete('category');
    qs.delete('sub');
    qs.delete('sub2');
    qs.delete('page');
    if (text) qs.set('q', text); else qs.delete('q');
    const path = `/search${qs.toString() ? `?${qs.toString()}` : ''}`;
    
    // 검색 실행 시 추천검색어 드롭다운 닫기
    setSearchFocused(false);
    
    router.push(path);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-[70] w-full h-16 bg-white/60 border-b border-zinc-200 backdrop-blur-sm">
      <div className="w-full h-full max-w-[1920px] mx-auto px-3 lg:px-4 lg:px-6 lg:px-8 lg:px-12 flex items-center justify-between">
        
        {/* 왼쪽: 로고 + 카테고리 네비게이션 */}
        <div className="flex items-center gap-4 lg:gap-6 lg:gap-8">
          {/* DW 로고 */}
          <div className="flex-shrink-0">
            <DWLogo />
          </div>

          {/* 카테고리 네비게이션 - 태블릿 이상에서 표시 */}
          <div className="hidden lg:flex items-center gap-6">
            <div className="flex items-center gap-6 lg:gap-8">
              {categories.length > 0 ? (
                categories
                  .filter(category => category.code !== 'ALL' && category.code !== 'ETC' && category.name !== '기타') // '전체'와 '기타' 카테고리 제외
                  .slice(0, 4) // 최대 4개 카테고리만 표시
                  .map((category) => (
                    <Link 
                      key={category.code}
                      href={`/reportlist?category=${encodeURIComponent(category.code)}`}
                      className="text-black text-base font-medium font-['Pretendard'] leading-normal hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap"
                    >
                      {category.name}
                    </Link>
                  ))
              ) : (
                // 카테고리 로딩 중일 때 기본 카테고리 표시
                <>
                  <span className="text-black text-base font-medium font-['Pretendard'] leading-normal whitespace-nowrap">커머스</span>
                  <span className="text-black text-base font-medium font-['Pretendard'] leading-normal whitespace-nowrap">마케팅</span>
                  <span className="text-black text-base font-medium font-['Pretendard'] leading-normal whitespace-nowrap">디자인</span>
                  <span className="text-black text-base font-medium font-['Pretendard'] leading-normal whitespace-nowrap">라이프</span>
                </>
              )}
            </div>
            <div className="w-px h-4 bg-gray-300 flex-shrink-0"></div>
            <Link href="/about" className="text-neutral-500 text-base font-medium font-['Pretendard'] leading-normal hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap">서비스 소개</Link>
          </div>
        </div>

        {/* 오른쪽: 햄버거 메뉴 + 로그인/사용자 메뉴 */}
        <div className="flex items-center gap-3">
          {/* 햄버거 메뉴 - 태블릿 이하에서만 표시 */}
          <div className="lg:hidden" data-mobile-menu>
            <HamburgerMenu 
              isOpen={mobileMenuOpen} 
              onClick={() => {
                setMobileMenuOpen(!mobileMenuOpen);
                setUserMenuOpen(false);
                setCategoryOpen(false);
                setSearchFocused(false);
              }} 
            />
          </div>

          {/* 로그인/사용자 메뉴 */}
          <div className="flex-shrink-0">
            {authLoading ? (
              <div className="w-20 h-8" aria-hidden="true" />
            ) : userName ? (
              <div id="dw-user-area" className="relative">
                <button onClick={onClickUser} aria-label="사용자 메뉴 토글" className="cursor-pointer">
                  <UserBadge name={userName} />
                </button>
                {userMenuOpen && (
                  <div className="absolute right-0 top-[44px] z-[60]">
                    <UserDropdown onLogout={onLogout} onProfile={openProfile} onPersonalization={openPersonalization} serviceExpiresAt={serviceExpiresAt} />
                  </div>
                )}
              </div>
            ) : (
              <button onClick={onLogin} className="px-3 py-2 lg:px-4 bg-black rounded-lg flex justify-center items-center gap-2.5 hover:opacity-80 transition-opacity cursor-pointer">
                <span className="text-white text-sm font-semibold font-['Pretendard'] whitespace-nowrap">로그인</span>
              </button>
            )}
          </div>
        </div>
      </div>

      {/* 모바일 메뉴 */}
      <MobileMenu isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} categories={categories} />

      <PersonalizationToast isVisible={showToast} onClose={() => setShowToast(false)} onAgree={handleAgreeClick} message={toastMessage} ctaText={toastCtaText} hideCTA={toastHideCTA} />
      <ProfileModal
        open={profileOpen}
        onClose={() => setProfileOpen(false)}
        onLogout={onLogout}
        userId={userId ?? undefined}
        defaultName={userName}
        defaultEmail={userEmail}
        defaultPhone={userPhone}
        defaultCompany={userCompany}
        initialMenu={(typeof window !== 'undefined' ? (window as any).__dw_profile_initial_menu__ : undefined) || 'profile'}
      />
      <BottomToast isVisible={loginToastVisible} message="전체 서비스를 이용하시려면 로그인 해주세요." variant="error" onClose={() => setLoginToastVisible(false)} />
    </header>
  );
}

